import Vue from 'vue';
import VueRouter from 'vue-router';
import VueGtm from '@gtm-support/vue2-gtm';

// import policies from 'policies';
import { i18n } from '@/setup/i18n';
import routes from 'routes';
import store from 'store';
import policies from 'policies';
import NProgressApp from 'utils/nprogress';
import { UI_SET_LOADER } from 'store/actions/ui';
import { AUTH_VALIDATE } from 'store/actions/auth';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  hashbang: false,
  root: '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes
});

// Trackings
const appGoogleTagManagerId = process.env.GOOGLE_TAG_MANAGER_ID;
if (process.env.NODE_ENV === 'production') {
  if (appGoogleTagManagerId) {
    Vue.use(VueGtm, {
      id: appGoogleTagManagerId,
      defer: false,
      enabled: true,
      loadScript: true,
      vueRouter: router,
      trackOnNextTick: false
    });
  }
}

// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

router.beforeEach((to, from, next) => {
  const titleKey = to.meta.titleKey;
  const titleByKey = titleKey ? `| ${i18n.t(`title.${to.meta.titleKey}`)}` : '';
  document.title = `${process.env.APP_NAME} ${titleByKey}`;

  // Añadimos el from en el meta porque es necesario para algunas redirecciones.
  const newTo = { ...to };
  newTo.meta.from = from;

  if (['error', '404', 'legal', 'access-denied'].indexOf(to.name) > -1) return next();

  // Valid always the Api token see action AUTH_VALIDATE in auth module
  return store
    .dispatch(`auth/${AUTH_VALIDATE}`)
    .then(() => {
      if (to.matched.some(m => m.meta.requiresAuth)) {
        // El policies es cuando sea concession
        policies.checkAuthAndRole(to, from, next);
      } else {
        next();
      }
    })
    .catch(() => {
      // Redirect to the error page
      redirectToErrorPage(next, AUTH_VALIDATE);
    });
});

// After navigation is confirmed, but before resolving...
router.beforeResolve((to, from, next) => {
  next();
});

// When each route is finished evaluating...
// eslint-disable-next-line no-unused-vars
router.afterEach(to => {
  // Loader hidden
  store.dispatch(`ui/${UI_SET_LOADER}`, false);
  // Complete the animation of the route progress bar.
  NProgressApp.done();
});

export { router as default };
